var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeightParcel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1760959580952,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 5557,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M875.025 54C928.031 54 971 96.97 971 149.975v725.05C971 928.032 928.032 971 875.025 971h-725.05C96.969 971 54 928.031 54 875.025v-725.05C54 96.97 96.97 54 149.975 54z m0 64h-725.05C132.315 118 118 132.316 118 149.975v725.05c0 17.66 14.315 31.975 31.975 31.975h725.05c17.66 0 31.975-14.315 31.975-31.975v-725.05c0-17.66-14.315-31.975-31.975-31.975zM431.588 429.477l0.312 0.428 74.554 104.202a64.774 64.774 0 0 1 6.046-0.282c35.333 0 63.975 28.642 63.975 63.975s-28.642 63.975-63.975 63.975-63.975-28.642-63.975-63.975c0-9.49 2.067-18.499 5.774-26.599L379.85 467.145c-10.283-14.373-6.968-34.361 7.405-44.645 14.23-10.18 33.962-7.033 44.333 6.977zM512.5 247.07c109.516 0 203.702 47.093 280.509 139.495 11.297 13.59 9.437 33.767-4.154 45.064-13.59 11.297-33.766 9.437-45.064-4.154-65-78.198-141.414-116.405-231.291-116.405-89.877 0-166.29 38.207-231.291 116.405-11.298 13.591-31.473 15.45-45.064 4.154-13.591-11.297-15.45-31.473-4.154-45.064C308.798 294.163 402.984 247.07 512.5 247.07z",
    "p-id": 5558,
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeightParcel);
export default __webpack_public_path__ + "static/media/weightParcel.41528cee4e417fcdbe10432fca345cbf.svg";
export { ForwardRef as ReactComponent };